<survey
  *ngIf="surveyModel"
  [model]="surveyModel"
  data-test-id="survey-form"
></survey>
